import request from '@/util/http'
import qs from 'qs'

// 主题列表查询
export const getSubjectList=(params)=>request({
    url: '/admin/subject/page',
    method: 'get',
    params
})

// 主题单个删除
export const handleSubjectDelete=(id)=>request({
    url: `/admin/subject/delete/${id}`,
    method: 'delete'
})
// 主题信息
export const getSubjectInfo=(id)=>request({
    url: `/admin/subject/get/${id}`,
    method: 'get'
})

// 保存主题
export const hallSaveOrUpdate=(data)=>request({
        url: '/admin/subject/saveOrUpdate',
        method: 'post',
        data:qs.stringify(data)
    })
